import SearchField from '@/components/common/SearchField';
import { useApplication } from '@/hooks/useApplication';
import { UserEventSortType } from '@/types/eventhandler';
import { filterUserEventsByQuery, sortUserEvents } from '@/util/sort';
import { userEventSearchOptions } from '@/util/userevents';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import { FC, useEffect, useState } from 'react';
import { useLocalStorage } from 'usehooks-ts';
import UserEventsManager from './UserEventsManager';

type UserEventsDialogProps = {
  open: boolean;
  onClose: () => void;
};

const UserEventsDialog: FC<UserEventsDialogProps> = (props) => {
  const { application } = useApplication();

  const [searchQuery, setSearchQuery] = useState('');
  const [sortBy, setSortBy] = useLocalStorage<UserEventSortType>('userEventSort', 'event');
  const [invert, setInvert] = useState<boolean>(false);

  useEffect(() => setSearchQuery(''), [props.open]);

  const userEvents = application.userevents ?? [];

  return (
    <Dialog open={props.open} onClose={props.onClose} fullWidth maxWidth='sm'>
      <DialogTitle>
        User Events
        {userEvents.length > 4 && (
          <SearchField
            searchQuery={searchQuery}
            setSearchQuery={(query) => setSearchQuery(query)}
            sortBy={sortBy}
            invert={invert}
            onSort={(changeSortBy, reverse) => {
              changeSortBy && setSortBy(changeSortBy as UserEventSortType);
              reverse && setInvert(!invert);
            }}
            searchOptions={userEventSearchOptions}
          />
        )}
      </DialogTitle>
      <DialogContent>
        <UserEventsManager
          userEvents={filterUserEventsByQuery(sortUserEvents(userEvents, sortBy, invert), searchQuery)}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={props.onClose} color='primary'>
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default UserEventsDialog;
